/* Sok: b2b-price-guard.js */
/* b2b: Guest price guard + message injection
   - Guests: add "Log in to view prices" link anywhere a price container exists
   - Logged in: do nothing
   - Works for:
     - Dawn/Trade price markup (.price__container / .price / [data-price] etc.)
     - Boost Smart Filter markup (.boost-sd__product-price)
*/

/* Sok: Hard-coded destination (requested: go to login page, not application) */
window.SokB2BLoginUrl = window.SokB2BLoginUrl || '/account/login';

/* Sok: Message text */
window.SokB2BLoginText = window.SokB2BLoginText || 'Log in to view prices';

(function () {
  /* Sok: If logged in, never run guest guard */
  if (window.SokShowPrices === true) return;

  /* Sok: Helper - safe query to Array */
  function qsa(root, selector) {
    /* Sok: Always return a real array */
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  /* Sok: Helper - create the message node once per container */
  function buildMessageNode() {
    /* Sok: Wrapper */
    var wrap = document.createElement('div');
    wrap.className = 'Sok-b2b-login-message';

    /* Sok: Link */
    var a = document.createElement('a');
    a.className = 'Sok-b2b-login-link';
    a.href = window.SokB2BLoginUrl;
    a.textContent = window.SokB2BLoginText;

    /* Sok: Accessibility */
    a.setAttribute('aria-label', window.SokB2BLoginText);

    /* Sok: Assemble */
    wrap.appendChild(a);
    return wrap;
  }

  /* Sok: Helper - only insert if missing */
  function ensureMessageAfter(containerEl) {
    if (!containerEl || containerEl.nodeType !== 1) return;

    /* Sok: Avoid duplicates */
    var already = containerEl.parentElement && containerEl.parentElement.querySelector('.Sok-b2b-login-message');
    if (already) return;

    /* Sok: Insert message immediately after the container */
    var msg = buildMessageNode();

    if (containerEl.nextSibling) {
      containerEl.parentNode.insertBefore(msg, containerEl.nextSibling);
    } else {
      containerEl.parentNode.appendChild(msg);
    }
  }

  /* Sok: Targets that represent "where price normally appears" */
  var PRICE_CONTAINER_SELECTORS = [
    /* Sok: Dawn/Trade price containers */
    '.price__container',
    '.price',
    '[data-price]',
    '[data-sale-price]',
    '[data-compare-price]',

    /* Sok: Boost price container (often empty but exists) */
    '.boost-sd__product-price',
    '.boost-pfs-filter-product-item-price',
    '.boost-pfs-filter-product-item-price-wrapper'
  ].join(',');

  /* Sok: Insert messages for all currently-rendered items */
  function runInjectionPass(root) {
    /* Sok: Find every price container and add message after it */
    qsa(root || document, PRICE_CONTAINER_SELECTORS).forEach(function (el) {
      ensureMessageAfter(el);
    });
  }

  /* Sok: First pass on initial page load */
  function init() {
    /* Sok: Ensure body class exists (backup safety) */
    document.body.classList.add('Sok-hide-prices');

    /* Sok: Inject for existing DOM */
    runInjectionPass(document);

    /* Sok: Watch for dynamic rendering (Boost, infinite scroll, quick add, recommendations, etc.) */
    var obs = new MutationObserver(function (mutations) {
      /* Sok: For performance, only scan added nodes */
      mutations.forEach(function (m) {
        if (!m.addedNodes || !m.addedNodes.length) return;

        Array.prototype.forEach.call(m.addedNodes, function (node) {
          if (!node || node.nodeType !== 1) return;

          /* Sok: If the added node IS a price container or CONTAINS them, inject */
          if (node.matches && node.matches(PRICE_CONTAINER_SELECTORS)) {
            ensureMessageAfter(node);
          } else if (node.querySelector) {
            runInjectionPass(node);
          }
        });
      });
    });

    /* Sok: Observe the main page for app/theme updates */
    obs.observe(document.body, { childList: true, subtree: true });
  }

  /* Sok: DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();



